/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSchnellauswahl$Params {

/**
 * ID der Schnellauswahl die gelöscht werden soll
 */
  schnellauswahlId: string;
}

export function deleteSchnellauswahl(http: HttpClient, rootUrl: string, params: DeleteSchnellauswahl$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSchnellauswahl.PATH, 'delete');
  if (params) {
    rb.path('schnellauswahlId', params.schnellauswahlId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSchnellauswahl.PATH = '/v1/schnellauswahl/{schnellauswahlId}';
